import Select from "react-select";
import { useEffect, useMemo, useState } from "react";
import { useTheme } from "context/ThemeContext";
import { selectStylesDark, selectStylesLigth } from "utils/helpers/structs/selectStyles";
import InputLabel from "components/others/InputLabel";
import { useTranslation } from "react-i18next";
import { useSettings } from "context/SettingsContext";
import { tDirName } from "utils/helpers/i18n/tDirName";

const ExpendTypeSelect = ({value, isMulti=false, onChange, disabled = false, income=false}) => {
 
    const { t, i18n } = useTranslation(['Objects']);
    const { darkTheme } = useTheme();   
    const { localSettings } = useSettings();
    const [ selectTheme, setSelectTheme ] = useState(darkTheme?selectStylesDark:selectStylesLigth);
    const options = useMemo(
        () =>
            localSettings?.DIRS?.ExpendType
                ?.filter(et=>income ? et.expendIncome : !et.expendIncome)
                ?.map(et=>({value:et.ID, label: tDirName(t, et.i18nKey, et.expendName), def:et.expend_def})),
        [localSettings?.DIRS?.ExpendType, income, t, i18n.language]
    );    
 
    useEffect(()=>{
        setSelectTheme(darkTheme?selectStylesDark:selectStylesLigth);
    },[darkTheme])

    return (
        <InputLabel
            title={income ? t('addExpend.typeIncome') : t('addExpend.typeExpend')}>  
            <Select options={options}  
                isDisabled={disabled}
                styles={{
                    ...selectTheme, // Зберігаємо існуючі стилі
                    control: (base, state) => ({
                    ...base,
                    ...(selectTheme.control ? selectTheme.control(base, state) : {}), 
                    }), 
                }} 
                className="w-100"
                isMulti={isMulti}
                value={
                    isMulti 
                        ? options?.find(opt=> value?.include(opt.value))
                        : options?.find(opt=>(opt.value == value))}
                onChange={onChange}/>
        </InputLabel>
    )
}

export default ExpendTypeSelect;